import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-file-previewer',
  templateUrl: './file-previewer.component.html',
  styleUrls: ['./file-previewer.component.scss']
})
export class FilePreviewerComponent {

  public type: string;
  public name: string;
  public fileAsDataUrl: any;

  @Input() public set input(input: File){
    if(input){
      this.type = input.type;
      this.name = input.name;

      console.log('input :>> ', input);

      const reader = new FileReader();
      reader.addEventListener('load', (event: any)=> this.fileAsDataUrl = event.target.result)
      reader.readAsDataURL(input);

      console.log('this.fileAsDataUrl :>> ', this.fileAsDataUrl)

    }
  }

  constructor() { 
  }
}
